export const messages = {
    default: {
        heading: 'Uh-oh! It seems there’s an issue.',
        text: 'Please refresh, or contact support if the problem continues. Thanks for your patience!',
    },
    expiredSession: (count: number = 0) =>
        `It appears your session has expired. Redirecting in ${count} seconds...`,
    retry: 'Retry',
}
